import { Controller } from "@hotwired/stimulus"

// ============================================================
// NotConnectedModalController — 빈 슬롯 미접속 안내 모달
// ============================================================
// is_confirm=false 인 슬롯(앱에 한 번도 접속하지 않은 계정)의
// 상세보기 버튼 클릭 시, 상세 모달 대신 안내 모달을 표시한다.
//
// Targets:
//   modal — 표시/숨길 모달 컨테이너 요소
//
// Actions:
//   open(event)          — 모달 열기 (버튼 클릭 시 호출)
//   close()              — 모달 닫기
//   closeOnOverlay(event)— 배경(오버레이) 클릭 시 닫기
// ============================================================
export default class extends Controller {
  static targets = ["modal"]

  // ESC 키 핸들러 참조 (disconnect 시 제거용)
  #escHandler = null

  connect() {
    // ESC 키로 모달 닫기
    this.#escHandler = (e) => { if (e.key === "Escape") this.close() }
    document.addEventListener("keydown", this.#escHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.#escHandler)
    document.body.style.overflow = ""
  }

  // 모달 열기 — 빈 슬롯 상세보기 버튼 클릭 시 호출
  open(event) {
    event.preventDefault()
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  // 모달 닫기
  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  // 배경 오버레이 클릭 시 닫기 (모달 컨테이너 자체를 클릭한 경우만)
  closeOnOverlay(event) {
    if (event.target === this.modalTarget) this.close()
  }
}
